import React, { FC, ReactElement } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { get } from 'lodash';
import MarkdownRenderer from '../markdown-renderer/MarkdownRenderer';

interface MuiDialogProps {
	open: boolean | null;
	title: string;
	content: string | ReactElement;
	onClose?: () => void;
	onCloseButtonName?: string;
	onConfirm?: () => void;
	onConfirmButtonName?: string;
	hasError?: boolean;
}
const MuiDialog: FC<MuiDialogProps> = (props) => {
	const RenderContent = () => {
		if (typeof get(props, 'content', '') === 'string') {
			return <MarkdownRenderer markdown={get(props, 'content', '')} />;
		} else {
			return <>{get(props, 'content', '')}</>;
		}
	};
	return (
		<>
			<Dialog
				open={get(props, 'open', false)}
				onClose={get(props, 'onClose')}
				sx={{
					textAlign: 'left',
					'& .MuiDialog-paper': {
						backgroundColor: '#eeeeee',
						maxWidth: '55rem',
					},
				}}
			>
				<DialogTitle>{get(props, 'title', '')}</DialogTitle>
				<DialogContent>
					<RenderContent />
				</DialogContent>
				<DialogActions>
					{typeof get(props, 'onClose') === 'function' ?
						<Button variant='outlined' onClick={get(props, 'onClose')}>
							{get(props, 'onCloseButtonName', 'Abbrechen')}
						</Button>
					:	null}
					{typeof get(props, 'onConfirm') === 'function' ?
						!get(props, 'hasError', false) && (
							<Button variant='contained' onClick={get(props, 'onConfirm')}>
								{get(props, 'onConfirmButtonName', 'Bestätigen')}
							</Button>
						)
					:	null}
				</DialogActions>
			</Dialog>
		</>
	);
};

export default MuiDialog;
